"use client";

import { ConfigProvider } from "antd";
import React from "react";
import { StyleProvider } from "@ant-design/cssinjs";

export default function ThemeConfig({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
      <ConfigProvider theme={{
        token: {
          fontFamily: 'Futura',
          colorPrimary: '#D6BB6E',
          borderRadius: 4,

          // Alias Token
          colorBgContainer: '#f6ffed',
        },
      }}>
        <StyleProvider layer>
          {children}
        </StyleProvider>
      </ConfigProvider>
  )
}